import React from 'react';
import './Team.css';

const Team = () => {
  return (
    <section id="team" className="team">
      <div className="team-container">
        <div className="team-header">
          <p className="team-label">OUR FOUNDER</p>
          <h2 className="team-title">Meet Adv. Didar Kaur</h2>
          <p className="team-subtitle">The Legal Mind Behind LexPitch</p>
        </div>
        
        <div className="team-single">
          <div className="team-card-large">
            <div className="team-image-wrapper">
              <div className="team-image">
                <img src="/founderImage.jpeg" alt="Advocate Didar Kaur" />
                <div className="image-overlay"></div>
              </div>
              <div className="image-badge">BBA LLB</div>
            </div>
            
            <div className="team-info">
              <div className="team-header-info">
                <h3 className="team-name">Adv. Didar Kaur</h3>
                <p className="team-position">Founder & Legal Advisor</p>
              </div>
              
              <div className="divider"></div>

              <div className="team-content">
                <p className="team-bio">
                  A dedicated legal professional with deep expertise in business law, startup ecosystems, and commercial litigation — bringing precision and purpose to every client relationship.
                </p>
                
                <p className="team-bio-extended">
                  Specialised in intellectual property, compliance advisory, and legal strategy for high-growth ventures. Committed to empowering businesses through clear and practical legal counsel.
                </p>
              </div>
            </div>

            {/* Contact Information */}
            <div className="founder-contact">
              <div className="contact-item">
                <div className="contact-icon">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M2.5 5L8.33 9.17M17.5 5L11.67 9.17M2 4C2 3.45 2.45 3 3 3H17C17.55 3 18 3.45 18 4V16C18 16.55 17.55 17 17 17H3C2.45 17 2 16.55 2 16V4Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div className="contact-details">
                  <p className="contact-label">Email</p>
                  <a href="mailto:advdidar.lexpitch@gmail.com">advdidar.lexpitch@gmail.com</a>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-icon">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M3.5 2.5H6C6.5 2.5 7 3 7 3.5L8.5 8C8.6 8.5 8.4 9 7.9 9.3L5.9 10.5C6.9 12.9 9.1 15.1 11.5 16.1L12.7 14.1C13 13.6 13.5 13.4 14 13.5L18 15C18.5 15 19 15.5 19 16.5V19C19 19.5 18.5 20 18 20C9.7 20 3 13.3 3 5C3 4.5 3.5 4 4 4Z" fill="currentColor"/>
                  </svg>
                </div>
                <div className="contact-details">
                  <p className="contact-label">Phone</p>
                  <a href="tel:+919599513613">+91 9599513613</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Team;
